module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/february/mainvisual-title-pc-buyback_5060ee3ae263320b5715561f4ded3e56.png";